/**
 * Generated runtime TestId mirror for frontend/src/pages/NotFound.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const NotFoundTestIds = {
  btnBackToDashboard: "btn-back-to-dashboard",
  linkBackToDashboard: "link-back-to-dashboard",
  suggestion: (s_path_replace_____g: string) => `suggestion-${s_path_replace_____g}`,
  suggestionPrefix: () => "suggestion-" as TestIdPrefix
} as const;
